<template>
  <b-row>
    <b-col sm="8">
      <b-card header="Listado de Empresas">
        <div class="table-responsive">
          <div class="form-group form-inline pull-left">
            <input v-model="search" type="search" class="form-control" placeholder="Buscar"> &nbsp;
          </div>
          <div class="form-group form-inline pull-right">
            <button @click="newCompany" type="button" class="btn btn-primary">Nuevo</button>&nbsp;
            <download-excel
              class="btn btn-primary"
              :data="filteredCompanies"
              :fields="json_fields"
              name="Clientes.xls"
            >Descargar Excel</download-excel>
          </div>
          <table class="table table-striped table-hover table-bordered">
            <thead>
              <tr>
                <th>Razón Social</th>
                <th>Facturar a</th>
                <th>RUC</th>
              </tr>
            </thead>
            <tbody>
              <tr
                @contextmenu.prevent="selectCompany(company, k)"
                v-for="(company, k) in paginated('filteredCompanies')"
                :key="k"
              >
                <td>{{company.name}}</td>
                <td>{{company.company_bill ? company.company_bill.name : 'No indicado'}}</td>
                <td>{{company.ruc}}</td>
              </tr>
            </tbody>
          </table>
          <paginate
            name="filteredCompanies"
            :list="filteredCompanies"
            class="paginate-list"
            :per="10"
          ></paginate>
          <paginate-links
            for="filteredCompanies"
            :limit="5"
            :show-step-links="true"
            :step-links="{
                next: '>>',
                prev: '<<'
              }"
            :classes="{
                'ul': 'pagination',
                'li': 'page-item',
                'a': 'page-link',
              }"
          ></paginate-links>
          <context-menu id="context-menu" ref="ctxMenu">
            <li v-on:click="editCompany" class="ctx-item">Editar</li>
            <li v-on:click="goDetail" class="ctx-item">Detalle</li>
            <li v-on:click="newUser" class="ctx-item">Agregar solicitante</li>
            <li @click="removeCompany" class="ctx-item">Eliminar</li>
          </context-menu>
        </div>
      </b-card>
    </b-col>
    <b-col sm="4">
      <b-card header="Facturar a">
        <b-form @submit.prevent="send">
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text">Nombre</div>
            </div>
            <input type="text" class="form-control" id="inlineFormInputGroup" v-model="company_bill.name">
            <input type="submit" class="btn btn-primary" value="Guardar">
          </div>
        </b-form>
        <ul class="list-group">
          <li class="list-group-item d-flex justify-content-between align-items-center" v-for="(cb, k) in company_bills" :key="k">
            {{cb.name}}
            <h4>
              <span @click="editCompanyBill(cb)" style="cursor:pointer;" class="badge badge-secondary"><i class="fa fa-edit"></i></span>&nbsp;
              <span @click="removeCompanyBill(cb)" style="cursor:pointer;" class="badge badge-secondary"><i class="fa fa-trash"></i></span>
            </h4>
          </li>
        </ul>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import contextMenu from "vue-context-menu";
import api from "@/helpers/api";

export default {
  components: { contextMenu },
  data() {
    return {
      companies: [],
      company: {},
      company_bills: [],
      paginate: ["filteredCompanies"],
      search: "",
      key: null,
      company_bill: {
        name: ''
      },
      json_fields: {
        'Razón Social': 'name',
        'RUC': 'ruc'
      }
    };
  },
  mounted() {
    api.get("/companies").then(response => {
      this.companies = response.companies;
    });

    api.get("/company_bills").then(response => {
      this.company_bills = response.company_bills;
    });
  },
  computed: {
    filteredCompanies() {
      return this.companies.filter(company => {
        let condition = true
        let text = this.search
        if(text){
          condition = company.name.toLowerCase().includes(text.toLowerCase()) ||
                      (company.ruc && company.ruc.includes(text));
        }
        return company.active && condition;
      });
    }
  },
  methods: {
    editCompany() {
      let route = this.$router.resolve({path: `/company/edit/${this.company.id}`});
      window.open(route.href, '_blank');
      // this.$router.push({
      //   path: `/company/edit/${this.company.id}`
      // });
    },
    goDetail() {
      this.$router.push({
        path: `/company/detail/${this.company.id}`
      });
    },
    newUser() {
      this.$router.push({
        path: `/company/${this.company.id}/new/user`
      });
    },
    newCompany() {
      this.$router.push({
        path: `/company/new`
      });
    },
    selectCompany(company, key) {
      this.company = company;
      this.key = key;
      this.$refs.ctxMenu.open();
    },
    removeCompany(){
      api.put(`/company/${this.company.id}`, {active: false}).then(response => {
        
        let index = this.companies.findIndex(c => c.id === this.company.id)
        this.companies.splice(index, 1)
        this.$toastr.success(
          `La empresa ${this.company.name} ha sido eliminada.`,
          "Crear cliente",
          { positionClass: "toast-top-center", closeButton: true }
        );
      })
    },
    send(){
      if(!this.company_bill.name){
        this.$toastr.error(
          "Debes indicar nombre",
          "Facturar a",
          { positionClass: "toast-top-center", closeButton: true }
        );
        return false
      }

      this.company_bill.name = this.company_bill.name.toUpperCase()
      this.company_bill.code = this.company_bill.name.toUpperCase()

      if(this.company_bill.id){
        api.put(`/company_bill/${this.company_bill.id}`, this.company_bill).then(response =>{
          
          let index = this.company_bills.findIndex(c => c.id == this.company_bill.id)
          this.company_bills.splice(index, 1, response.company_bill)
          this.$toastr.success(
            'Registro actualizado',
            "Facturar a",
            { positionClass: "toast-top-center", closeButton: true }
          );
        }).catch(error => {
          this.$toastr.error(
            error,
            "Facturar a",
            { positionClass: "toast-top-center", closeButton: true }
          );
        })
      } else {
        api.post('/company_bill', this.company_bill).then(response =>{
          this.company_bills.push(response.company_bill)
          this.$toastr.success(
            'Registro guardado',
            "Facturar a",
            { positionClass: "toast-top-center", closeButton: true }
          );
        }).catch(error => {
          this.$toastr.error(
            error,
            "Facturar a",
            { positionClass: "toast-top-center", closeButton: true }
          );
        })
      }
      
    },
    editCompanyBill(cb){
      this.company_bill = cb
    },
    removeCompanyBill(cb){
      if(confirm(`¿Seguro desea eliminar ${cb.name}?`)){
        api.delete(`/company_bill/${cb.id}`).then(response => {
          let index = this.company_bills.findIndex(c => c.id == cb.id)
          this.company_bills.splice(index)

          this.$toastr.success(
            'Registro eliminado',
            "Facturar a",
            { positionClass: "toast-top-center", closeButton: true }
          );
        }).catch(error => {
          this.$toastr.error(
            error,
            "Facturar a",
            { positionClass: "toast-top-center", closeButton: true }
          );
        })
      }
    }
  },
};
</script>
